/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function sum(a, b) {
  return a + b;
}
function getGroupedItems(_ref) {
  var boxes = _ref.boxes,
    maxSize = _ref.maxSize,
    _ref$overflowControlS = _ref.overflowControlSize,
    overflowControlSize = _ref$overflowControlS === void 0 ? 0 : _ref$overflowControlS;
  var boxesSize = boxes.reduce(sum);
  if (boxesSize <= maxSize) {
    return false;
  }
  var availableSize = maxSize - overflowControlSize;
  var groups = boxes.reduce(function (acc, box, index) {
    if (availableSize - box >= 0) {
      acc.visibleIndexes.push(index);
      availableSize -= box;
    } else {
      availableSize = 0;
      acc.overflowIndexes.push(index);
    }
    return acc;
  }, {
    visibleIndexes: [],
    overflowIndexes: []
  });
  return groups;
}
var _default = getGroupedItems;
exports.default = _default;